var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Component from "nuxt-class-component";
import { TsVue } from "~/plugins/TsVue";
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.content = [
            {
                icon: '/images/hrm/icons/icon_1.png',
                text: '应收款项'
            },
            {
                icon: '/images/hrm/icons/icon_2.png',
                text: '应付款项'
            },
            {
                icon: '/images/hrm/icons/icon_3.png',
                text: '对账管理'
            },
            {
                icon: '/images/hrm/icons/icon_4.png',
                text: '凭证管理'
            },
            {
                icon: '/images/hrm/icons/icon_5.png',
                text: '发票管理'
            },
            {
                icon: '/images/hrm/icons/icon_6.png',
                text: '余额管理'
            },
            {
                icon: '/images/hrm/icons/icon_7.png',
                text: '充值提现'
            },
            {
                icon: '/images/hrm/icons/icon_8.png',
                text: '统计报表'
            }
        ];
        _this.functionList = [
            {
                title: '人才选育留用',
                icon: '/images/hrm/icons/icon_top_1.png',
                text: '企业文化宣导、人员内部激励、HR政策与方案制定、执行情况监督改进'
            },
            {
                title: '业务功能',
                icon: '/images/hrm/icons/icon_top_2.png',
                text: '提升团队凝聚力、人力资源与业务深度结合、人力资源业务合作伙伴'
            },
            {
                title: '服务功能',
                icon: '/images/hrm/icons/icon_top_3.png',
                text: '员工考勤、工资单制作、五险一金缴纳、员工劳动合同签订、建立筛选、面试安排'
            }
        ];
        _this.architecture = [
            {
                title: '核心人力资源市场',
                items: [
                    '组织架构',
                    '岗位规划、招聘与配置',
                    ['劳动时间管理', '薪酬、社保福利管理'],
                    ['培训与开发', '人事、劳动关系'],
                    '绩效考核',
                    '能力素质模型'
                ]
            },
            {
                title: '行政后勤管理',
                items: [
                    '后勤住宿、物品领用',
                    '门禁、消费报销'
                ]
            }
        ];
        return _this;
    }
    default_1.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2];
            });
        });
    };
    default_1 = __decorate([
        Component({
            components: {}
        })
    ], default_1);
    return default_1;
}(TsVue));
export default default_1;



//////////////////
// WEBPACK FOOTER
// /opt/node_modules/ts-loader?{"appendTsSuffixTo":[{}],"transpileOnly":true}!/opt/node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/services/hrm/Content.vue
// module id = vLz0
// module chunks = 19